import { z } from 'zod';
export const USER_ROLES = ['ADMIN', 'MEMBER'];
export const userRoleSchema = z.enum(USER_ROLES);
export const adminUserSchema = z.object({
    id: z.uuid(),
    email: z.email(),
    displayName: z.string(),
    role: userRoleSchema,
});
export const meResponseSchema = z.object({
    user: adminUserSchema,
    totp: z.object({
        /** TOTP activé sur le compte (enrôlement terminé). */
        enrolled: z.boolean(),
        /** Session courante validée par TOTP ou code de récupération. */
        verified: z.boolean(),
    }),
    /** Fin absolue de la session (ISO 8601). */
    sessionExpiresAt: z.iso.datetime(),
});
/** Code TOTP : 6 chiffres, espaces tolérés à la saisie. */
export const totpCodeSchema = z
    .string()
    .transform((value) => value.replace(/\s+/g, ''))
    .pipe(z.string().regex(/^\d{6}$/, 'Saisissez les 6 chiffres affichés par votre application.'));
export const totpVerifyRequestSchema = z.object({ code: totpCodeSchema });
export const recoveryCodeRequestSchema = z.object({
    code: z
        .string()
        .trim()
        .min(10, 'Code de récupération incomplet.')
        .max(16, 'Code de récupération trop long.'),
});
export const totpEnrollmentResponseSchema = z.object({
    /** URI otpauth:// à afficher en QR code, une seule fois. */
    otpauthUri: z.string().startsWith('otpauth://'),
    /** Clé en base32 pour une saisie manuelle. */
    secret: z.string().min(16),
});
export const recoveryCodesResponseSchema = z.object({
    recoveryCodes: z.array(z.string()).length(10),
});
/** Connexion par e-mail et mot de passe (comptes définis dans la configuration du serveur). */
export const loginRequestSchema = z.object({
    email: z.email('Saisissez une adresse e-mail valide.'),
    password: z.string().min(1, 'Saisissez votre mot de passe.').max(256),
});
/** Connexion de développement (sans mot de passe, hors production, pour les tests). */
export const devLoginRequestSchema = z.object({ email: z.email() });
export const authProvidersResponseSchema = z.object({
    /** Au moins un mot de passe est configuré sur le serveur. */
    password: z.boolean(),
    devLogin: z.boolean(),
});
//# sourceMappingURL=auth.js.map